import axios from "axios";
import { getApiUrl } from "./common";

export const getAccessToken = function() {
  let token = localStorage.getItem("access_token");
  if (!token) {
    return "";
  }
  return token;
};

export async function request(option) {
  let response;
  try {
    response = await axios(option);
  } catch (e) {
    if (e && e.response && e.response.status !== 200) {
      const body = e.response.data;
      if (body && typeof body === "object" && "code" in body && "msg" in body) {
        throw body;
      }
      throw { code: e.response.status, msg: e.message };
    }
    throw { code: 500, msg: e.message };
  }

  return response.data;
}

export const createApi = (url, data) => {
  let headers = {
    "Access-Token": getAccessToken(),
  };

  let param = {
    url: getApiUrl(url),
    data,
    method: "post",
    headers,
  };

  return request(param);
};
